/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import ApiCredentialsService from 'cio/services/api-credentials';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import ApiCredentialModel from 'cio/models/api-credential';

export default class LoadApiCredentials extends Component {
  @service apiCredentials!: ApiCredentialsService;

  @tracked selectedCredential?: ApiCredentialModel;

  constructor(owner: unknown, args: any) {
    super(owner, args);

    this.setupCredentials.perform();
  }

  setupCredentials = task({ drop: true }, async () => {
    let credentials = await this.apiCredentials.loadCurrentEnvironmentCredentials.perform();

    if (credentials.length === 1) {
      this.selectedCredential = credentials.firstObject;
    }

    return credentials;
  });

  @action
  onSelect(credential: ApiCredentialModel) {
    this.selectedCredential = credential;
  }
}
